import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(5)};
`;

export const ContentContainer = styled.div`
  align-self: center;
  flex: 1 1 auto;
  padding: 0 ${pxToRem(5)};
  &:first-child {
    padding-left: 0;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  flex: 1 1 auto;
  height: ${pxToRem(32)};
  max-width: ${pxToRem(300)};
  min-width: ${pxToRem(300)};
  .ui.input {
    width: 100%;
  }
`;

export const ToolbarContainer = styled.div<{ $hasOverlay: boolean; $isIterableStyle: boolean }>`
  display: flex;
  background: ${({ $isIterableStyle }) => ($isIterableStyle ? 'none' : '#eff0f0')};
  padding: ${({ $isIterableStyle }) => ($isIterableStyle ? `${pxToRem(10)} 0` : pxToRem(10))};
  flex: 1 0 auto;
  border-top-left-radius: ${pxToRem(3)};
  border-top-right-radius: ${pxToRem(3)};
  .bulkActions {
    padding-left: 0;
  }
  ${({ $hasOverlay }) =>
    $hasOverlay
      ? `
    position: relative;
    .content {
        opacity: 0;
    }
  `
      : ''};
`;
